import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import Slider from 'react-slick';
import {FormattedMessage} from 'react-intl';
import { LightgalleryItem } from "react-lightgallery";

import api from '../../config/api';
import {completeUrlsForItem} from '../../util/utils';
import SearchForm from '../form/SearchForm';
import FileList from '../common/FileList';

class ProductDetailsPage extends Component {

	/**
	 *
	 * @param props
	 */
	constructor(props) {
		super(props);

		this.state = {
			selectedProduct: {},
			images: [],
			selectedTab: 0,
		};

		this.imageSliderSettings = {
			autoplay: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			dots: false,
			infinite: false,
			speed: 500
		};

		this.thumbnailSliderSettings = {
			autoplay: false,
			dots: false,
			arrows: true,
			infinite: false,
			speed: 500,
			vertical: true,
			verticalSwiping: false,
			draggable: false,
			slidesToShow: 6,
			slidesToScroll: 1
		};

		this.tabs = ['more-features', 'accessories', 'downloads'];
	}

	componentWillMount() {
		const {selectedLanguage, match} = this.props;
		this.loadProduct(selectedLanguage, match.params.productUrl);
	}

	componentWillReceiveProps(nextProps) {
		const {selectedLanguage, match} = nextProps;
		if (this.props.match.url !== match.url) {
			this.setState({
				selectedProduct: {},
				images: [],
				selectedTab: 0,
			});
			this.loadProduct(selectedLanguage, match.params.productUrl);
		}
	}

	/**
	 * Get ID from product url
	 * @returns {*}
	 */
	getIdFromProductUrl = (productUrl) => {
		return productUrl.split('-')[0];
	};

	/**
	 * Load product from API
	 */
	loadProduct = (language, productUrl) => {
		fetch(api.productDetails(this.getIdFromProductUrl(productUrl), language.codeCountry))
			.then(res => res.json())
			.then(data => {
				this.setState({
					selectedProduct: completeUrlsForItem(data),
					images: data.imageUrls
				});
			}).catch(err => console.error(err));
	};


	/**
	 * Handling tab clicking
	 * @param e
	 * @param key
	 */
	handleSelect = (e, key) => {
		this.setState({
			selectedTab: key
		});
	};

	renderImageContainer = (images) => {
		if (images === undefined || images.length === 0) {
			return (
				<div className="product-details__image product-details__image--no-image"/>
			);
		}
		return (
			<div className="product-details__image">
				{this.renderImageSlider(images)}
				{this.renderThumbnailSlider(images)}
			</div>
		);
	};

	/**
	 * Render image slider
	 * @param images
	 * @returns {*}
	 */
	renderImageSlider = (images) => {
		if (images === undefined || images.length === 0) {
			return null;
		}
		return (
			<Slider className="product-details__image-slider"
					ref={slider => this.imageSlider = slider}
					{...this.imageSliderSettings}>
				{images.map(this.renderImageSliderItem)}
			</Slider>
		);
	};

	/**
	 * Render thumbnail slider
	 * @param images
	 * @returns {*}
	 */
	renderThumbnailSlider = (images) => {
		if (images === undefined || images.length === 0) {
			return null;
		}
		return (
			<Slider className="product-details__thumbnail-slider"
					{...this.thumbnailSliderSettings}>
				{images.map(this.renderThumbnailSliderItem)}
			</Slider>
		);
	};

	/**
	 * Render image slider items
	 * @param image
	 * @param index
	 * @returns {XML}
	 */
	renderImageSliderItem = (image, index) => {
		return (
			<div key={index} className="product-image-slider">
				<LightgalleryItem group="image-slider" src={image}>
					<div className="product-image-slider__item"
						 style={{backgroundImage: 'url(' + image + ')'}}
						 title={this.state.selectedProduct.name}/>
				</LightgalleryItem>
			</div>
		);
	};

	/**
	 * Render image slider items
	 * @param image
	 * @param index
	 * @returns {XML}
	 */
	renderThumbnailSliderItem = (image, index) => {
		return (
			<div key={index} className="product-image-slider" onClick={e => this.handleSlideClick(e, index)}>
				<div className="product-image-slider__item"
					 style={{backgroundImage: 'url(' + image + ')'}}
					 title={this.state.selectedProduct.name}/>
			</div>
		);
	};

	/**
	 *
	 * @param e
	 * @param index
	 */
	handleSlideClick = (e, index) => {
		e.preventDefault();
		this.imageSlider.slickGoTo(index);
	};

	renderBannerTitle = () => {
		const product = this.state.selectedProduct;

		if (product.type) {
			return (
				<h2>
					<FormattedMessage id={'product.title.type-' + product.type.toLowerCase()}/>
				</h2>
			)
		}
		return null;
	};

	/**
	 * Render more features section
	 * @returns {null}
	 */
	renderMoreFeaturesSection = () => {
		const {selectedTab, selectedProduct: product} = this.state;
		if (product.moreFeatures && selectedTab === 0) {
			return (
				<div className="product-details__more-features">
					<div className="more-features__content"
						 dangerouslySetInnerHTML={{__html: product.moreFeatures}}/>
				</div>
			);
		}
		return null;
	};

	/**
	 * Render file downloads section
	 * @returns {*}
	 */
	renderAccessoriesSection = () => {
		const {selectedLanguage, localizePath} = this.props;
		const {selectedTab, selectedProduct: product} = this.state;
		if (product.accessories !== null && product.accessories !== undefined && selectedTab === 1) {
			return (
				<div className="product-details__accessories">
					<ul className="product-accessory-list">
						{
							product.accessories.map((item, index) => (
								<li key={index}>
									{item.name[selectedLanguage.codeCountry]}
									<a className="btn btn-download" href={localizePath(`/product/${item.url}`)}
									   target="_blank">
										<FormattedMessage id="product.link.accessory"/>
									</a>
								</li>
							))
						}
					</ul>
				</div>
			);
		}

		return null;
	};

	/**
	 * Render file downloads section
	 * @returns {*}
	 */
	renderDownloadsSection = () => {
		const {selectedTab, selectedProduct: product} = this.state;
		if (product.files !== null && product.files !== undefined && selectedTab === 2) {
			const filteredFiles = product.files.filter(file => !file.fileType.includes('TUTORIAL'));
			if (filteredFiles.length > 0) {
				return (
					<div className="product-details__downloads">
						<FileList files={filteredFiles}/>
					</div>
				);
			}
		}

		return null;
	};

	/**
	 *
	 * @returns {*}
	 */
	renderTutorialSection = () => {
		const {selectedTab, selectedProduct: product} = this.state;
		if (product.files !== null && product.files !== undefined && selectedTab === 2) {
			const filteredFiles = product.files.filter(file => file.fileType.includes('TUTORIAL'));
			if (filteredFiles.length > 0) {
				return (
					<div className="product-details__tutorials">
						<h3 className="product-details__section-title">
							<FormattedMessage id="product.title.tutorials"/>
						</h3>
						<div className="product-details__tutorials-list">
							{filteredFiles.map((file, index) => this.renderTutorial(file, index))}
						</div>
					</div>
				);
			}
		}

		return null;
	};

	/**
	 *
	 * @param file
	 * @param index
	 * @returns {*}
	 */
	renderTutorial = (file, index) => {
		return (
			<div className="tutorial-item" key={index}>
				<div className="embed-responsive embed-responsive-16by9">
					<iframe className="embed-responsive-item" src={file.link} frameBorder="0"
							allow="autoplay; encrypted-media" allowFullScreen/>
				</div>
				<h3>{file.name}</h3>
			</div>
		)
	};

	/**
	 * Render redirect section
	 * @returns {*}
	 */
	renderRedirectSection = () => {
		const product = this.state.selectedProduct;
		const navs = this.props.navs;

		if (product.type && navs.mainNav.items) {
			const linkTo = this.getLinkTo(product, navs.mainNav.items);
			if (linkTo === null) {
				return null;
			}
			return (
				<div className="product-details__back">
					<Link className="btn btn-amiko" to={linkTo}>
						<FormattedMessage id={'product.link.back-to-' + product.type.toLowerCase()}/>
					</Link>
				</div>
			)
		}
		return null;
	};

	getLinkTo = (product, list) => {
		let linkTo = null;
		for (let i = 0; i < list.length; i++) {
			if (linkTo !== null) {
				break;
			}
			if (list[i].code === product.type) {
				linkTo = list[i].linkTo;
				break;
			}
			if (list[i].subItems.length > 0) {
				linkTo = this.getLinkTo(product, list[i].subItems);
			}
		}
		return linkTo;
	};


	/**
	 * Rendering tabs
	 * @returns {*}
	 */
	renderTabs = () => {
		const {selectedTab} = this.state;
		return (
			<div className="product-details__tab-container">
				<ul className="tab-list">
					{
						this.tabs.map((tab, index) => (
							<li key={index} className={selectedTab === index ? 'active' : ''}
								onClick={e => this.handleSelect(e, index)}>
								<FormattedMessage id={'product.title.' + tab}/>
							</li>
						))
					}
				</ul>
			</div>
		);
	};

	renderIcons = () => {
		const {selectedProduct: product} = this.state;
		if (product.icons === undefined || product.icons.length <= 0) {
			return null;
		}
		return (
			<ul className="product-details__icons">
				{
					product.icons.map((icon, index) => (
						<li key={index}>
							<img src={icon.url} alt={icon.name}/>
						</li>
					))
				}
			</ul>
		)
	};

	render() {
		const {selectedProduct: product} = this.state;

		const bannerClassName = product.type
			? 'page__banner page__banner--' + product.type.toLowerCase()
			: 'page__banner';

		return (
			<div className="container-flex">
				<div className={bannerClassName}>
					{this.renderBannerTitle()}
				</div>
				<SearchForm {...this.props} />
				<div className="page__title page__title--product-details">
					<span>{product.name}</span>
					{this.renderIcons()}
				</div>
				<div className="page">
					<div className="page__content page__content--product-details">
						<div className="product-details__description">
							<div className="description__content"
								 dangerouslySetInnerHTML={{__html: product.description}}/>
						</div>
						{this.renderImageContainer(this.state.images)}
						{this.renderTabs()}
						{this.renderMoreFeaturesSection()}
						{this.renderAccessoriesSection()}
						{this.renderDownloadsSection()}
						{this.renderTutorialSection()}
						{this.renderRedirectSection()}
					</div>
				</div>
			</div>
		);
	}
}

export default ProductDetailsPage;


// WEBPACK FOOTER //
// ./src/components/page/ProductDetailsPage.js